(function ($, DGS) {
  DGS.OnLoad.getInstance().register(function () {
    var layout;
    if (DGS.UserAgent.getInstance().mobileTabletCheck()) {
      layout = DGS.MOBILE_LAYOUT;
    } else {
      layout = DGS.DESKTOP_LAYOUT;
    }

    /*
    * Listen to the resource center to make sure the lightbox exists.
    * The event is called on successful ajaxing of base script.
    */
    $('.resource-center').on('resource-center:show-lightbox', function (e) {
      // Only add the class if we are on dekstop
      if (layout === DGS.DESKTOP_LAYOUT) {
        $('body').addClass('no-scroll');
      }
      $('.lighbox-close').click(function () {
        $('body').removeClass('no-scroll');
      });
      $('.detail-lightbox.outer-container').on("click", function (e) {
        $('body').removeClass('no-scroll');
        $('.lighbox-close').trigger('resource-center:hide-lightbox');
      });

      /*
      * This is needed to interrupt the event propagation if the inner container is clicked.
      */
      $('.detail-lightbox.outer-container > .inner-container').on("click", function (e) {
        e.stopPropagation();
      });
    });
  });
})(jQuery, window.DGS);